module.exports = __webpack_public_path__ + "img/tarj-2.f30e0702.svg";